module.exports = __webpack_public_path__ + "public/img/17.cf695629.png";